import React from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';

function PrecoFormatted(props) {
  const { inputRef, onChange, ...other } = props;

  return (
    <NumberFormat
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...other}
      allowNegative={false}
      decimalScale={2}
      decimalSeparator=","
      getInputRef={inputRef}
      onValueChange={values => {
        onChange({
          target: {
            value: values.floatValue,
            name: other.name,
          },
        });
      }}
      thousandSeparator="."
    />
  );
}

PrecoFormatted.propTypes = {
  inputRef: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default PrecoFormatted;
